<template>
  <div>
    <div class="timeline-multi timeline-collapse mt-m10">
      <DeliveryDetails
        :deliveryId="deliveryId"/>
      <div class="timeline-right">
        <h6 class="ml-15">Carton Audit</h6>
        <div v-for="(source, index) in deliveryTag" :key="index" :name="index">
                <CartonAudit
                  :key="index"
                  :isCartonFetchOpen="isCartonFetchOpen"
                  :deliveryId="deliveryId"
                  :material="source"/>
        </div>
        <infinite-loading @infinite="loadCartonDetails"  slot="append">
          <div slot="no-more"></div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </div>
  </div>
</template>
<script>
import DeliveryDetails from './DeliveryDetails';
import CartonAudit from './CartonAudit';
import { mapGetters } from 'vuex';

export default {
  components: {
    DeliveryDetails,
    CartonAudit,
  },
  props: ['deliveryId', 'order', 'deliveryIdList'],
  computed: {
    ...mapGetters({
      deliverySummary: 'order/deliverySummary',
      currentUser: 'app/currentUser',
      cartonPageCount: 'order/subDeliveryPage',
      hasEmpty: 'order/hasEmptySubDeliveryList',
      isCartonFetchOpen: 'order/isCartonFetchOpen',
    }),
    deliveryDetails() {
      return (this.deliverySummary &&
        this.deliverySummary.find(val => val.delivery_id.toString() === this.deliveryId.id.toString())) || {};
    },
  },
  created(){
    this.$store.commit('order/SET_CARTON_FETCH', false);
  },
  data() {
    return {
      deliveryTag: [],
      cartonDetails: 1,
    };
  },
  methods: {
    getMaterials(materials) {
      const materialsList = materials ? Object.keys(materials) : [];
      return materialsList.map((deliveryId) => {
        return {
          deliveryId,
          material_ref_id: (materials[deliveryId].length
            && materials[deliveryId][0].material_ref_id) || '',
        };
      });
    },
    async loadCartonDetails($state = null) {
      try {
        const deliveryJobId = (this.deliveryId && this.deliveryId.job) || (this.deliveryDetails && this.deliveryDetails.job_id);
        if (deliveryJobId) {
          const result = await this.$store.dispatch('order/getCartonDetails', {
            orderNo: this.orderNumber,
            jobId: deliveryJobId,
            page: this.cartonDetails,
          });
          if (!result) {
            $state.complete();
            this.$errorMessage({ message: this.$t('GENERAL ERROR') });
          } else if (result && result.error) {
            $state.complete();
            this.$errorMessage({ message: result.error });
          } else if (result.length) {
            $state.loaded();
            this.cartonDetails += 1;
            this.deliveryTag.push(...result);
          } else {
            $state.complete();
          }
        } else {
          $state.complete();
        }
      } catch (err) {
        $state.complete();
        this.$errorMessage({ message: this.$t('APP_CATCH_ERR') });
      }
    },
  },
};
</script>
